export default __webpack_public_path__ + "static/media/sample1.72e85eb7.png";